<template>
    <BaseDialog
        :visible="dialog"
        :type="type"
        :form="form"
        title="zařízení"
        @close="dialog=false"
        @process="processForm"
    >
        <v-text-field
                v-model="form.name"
                type="text"
                label="Jméno"
                :rules="formRules.name"
        />
        <v-text-field
                v-model="form.username"
                type="text"
                label="Přihlašovací jméno"
                :rules="formRules.name"
        />
        <v-select
                :items="users"
                item-text="username"
                item-value="id"
                v-model="form.user"
                label="Uživatel"
                required
                :rules="formRules.user"
                v-if="$store.state.user.logged.isSuperuser"
        ></v-select>
        <v-text-field
                v-model="form.password"
                type="text"
                label="Heslo"
                :hint="type === 'edit' ? 'Vyplňte heslo, pokud ho chcete změnit':''"
                :rules="formRules.password"
                persistent-hint
        />
    </BaseDialog>
</template>

<script>
    import BaseDialogMixin from '../../mixins/BaseDialogMixin'

    export default {
        mixins: [BaseDialogMixin],

        data: () => ({
            form: {
                id: 0,
                name: '',
                username: '',
                password: '',
                user: null
            },
            formRules: {
                name: [v => v !== '' || 'Vyplňte hodnotu'],
                username: [v => v !== '' || 'Vyplňte hodnotu'],
                password: [],
                user: []
            }
        }),

        mounted () {
            if (this.$store.state.user.logged.isSuperuser) {
                this.$store.dispatch('user/list')
            }
        },

        computed: {
            users () {
                return this.$store.state.user.list
            }
        },

        methods: {
            postShow () {
                if (this.type === 'add') {
                    this.formRules['password'] = [v => v !== '' || 'Vyplňte heslo']
                } else {
                    this.formRules['password'] = []
                }
                if (this.$store.state.user.logged.isSuperuser) {
                    this.formRules['user'] = [v => v !== '' || 'Vyberte uživatele']
                } else {
                    this.formRules['user'] = []
                }
            }
        }
    }
</script>
